export const getHourOption = (distData: any) => {
    if (!distData) return {};
    const hours = Array.from({ length: 24 }, (_, i) => i + '点');
    const data = Array.from({ length: 24 }, (_, i) => distData.hour_dist[i] || 0);

    return {
        title: {
            text: '24小时订单分布',
            textStyle: { fontSize: 14, fontWeight: 600, color: '#1f2937' },
            left: 'center'
        },
        tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            borderColor: '#e5e7eb',
            textStyle: { color: '#374151' }
        },
        grid: { left: '3%', right: '4%', bottom: '10%', top: '18%', containLabel: true },
        xAxis: {
            type: 'category',
            data: hours,
            axisLabel: { color: '#6b7280', fontSize: 10 },
            axisLine: { lineStyle: { color: '#e5e7eb' } },
            axisTick: { show: false }
        },
        yAxis: {
            type: 'value',
            axisLabel: { color: '#6b7280' },
            splitLine: { lineStyle: { color: '#f3f4f6', type: 'dashed' } },
            axisLine: { show: false }
        },
        series: [{
            name: '订单量',
            type: 'bar',
            data,
            barMaxWidth: 20,
            itemStyle: {
                color: {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#818cf8' },
                        { offset: 1, color: '#c4b5fd' }
                    ]
                },
                borderRadius: [3, 3, 0, 0]
            }
        }]
    };
};
